const initState = {
    getAll: {
        data: [],
        /**control */
        connection: false,
        error: false,
        message: "",
    },
    getById:{
        data: {messages:[], users:[]},
        /**control */
        connection: false,
        error: false,
        message: "",
    },
    create:{
        result:false,
        /**control */
        connection: false,
        error: false,
        message: "",
    },
    update:{
        result:false,
        /**control */
        connection: false,
        error: false,
        message: "",
    }
};

export default initState;